import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import Row from '../../../core/layout/Row';
import Table from '../../../core/form/Table';
import Select from '../../../core/form/Select';
import Button from '../../../core/form/Button';
import Async from '../../../core/layout/Async';
import Column from '../../../core/layout/Column';
import TextInput from '../../../core/form/TextInput';
import Separator from '../../../core/layout/Separator';
import FormButtons from '../../../core/form/FormButtons';
import EmailTemplateUploadFormContainer from './EmailTemplateUploadFormContainer';

const EmailTemplateForm = (props) => (
  <form
    onSubmit={(event) => {
      event.preventDefault();
      props.onSubmit();
    }}
  >
    <Row>
      <Column size={2}>
        <Select
          required
          label="Type"
          disabled={props.submitting || props.loading || !!get(props.values, 'id')}
          value={get(props.values, 'type', '')}
          onChange={(value) => props.onChange('type', value)}
          errorText={get(props.errors, 'type', null)}
          options={[
            {
              label: 'Student',
              value: 'STUDENT',
            },
            {
              label: 'Kids',
              value: 'KIDS',
            },
            {
              label: 'Parent',
              value: 'PARENT',
            },
            {
              label: 'Admin',
              value: 'ADMIN',
            },
            {
              label: 'Partner Dashboard',
              value: 'PARTNER',
            },
          ]}
        />
      </Column>
      <Column size={3}>
        <TextInput
          required
          label="Key"
          disabled={props.submitting || props.loading || !!get(props.values, 'id')}
          value={get(props.values, 'key', '')}
          onChange={(value) => props.onChange('key', value)}
          errorText={get(props.errors, 'key', null)}
        />
      </Column>
    </Row>
    <EmailTemplateUploadFormContainer
      selectedLocales={get(props.values, 'templates', []).map((template) => template.locale)}
    />
    <Row>
      <Async fetching={props.loading}>
        <Table
          columns={[
            {
              label: 'Locale',
              path: 'locale',
              sort: true,
              defaultSortOrder: 'ascend',
              width: '80px',
            },
            {
              label: 'Subject',
              path: 'subject',
              editable: true,
            },
            {
              label: 'Actions',
              width: '125px',
              render: (cell, row) => (
                <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                  {typeof row.template === 'string' && (
                    <Button icon="download" onClick={() => props.onTemplateDownload(row.template)} />
                  )}
                  <Button icon="edit" onClick={() => props.onEdit(row.locale)} />
                  <Button icon="delete" onClick={() => props.onDelete(row.locale)} />
                </div>
              ),
            },
          ]}
          rows={get(props.values, 'templates', [])}
          rowKey="locale"
        />
      </Async>
    </Row>
    <Separator />
    <FormButtons
      confirmLabel={`${get(props.values, 'id') ? 'Update' : 'Create'} Email Template`}
      isDisabled={props.submitting || props.loading}
      isSubmitting={props.submitting}
      onReset={props.onReset}
    />
  </form>
);

EmailTemplateForm.propTypes = {
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
  onReset: PropTypes.func,
  onTemplateDownload: PropTypes.func,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  values: PropTypes.object,
  submitting: PropTypes.bool,
  loading: PropTypes.bool,
  errors: PropTypes.object,
};

EmailTemplateForm.defaultProps = {
  values: {},
  errors: {},
  submitting: false,
  loading: false,
  onSubmit: () => false,
  onReset: () => false,
  onTemplateDownload: () => false,
};

export default EmailTemplateForm;
